<template>
    <div>
        <h1>Settings</h1>
        <p>Recommended Plugins page</p>
    </div>
</template>